import React, { useState } from 'react';
import Slider from 'react-slick';
import { Icon } from '@iconify/react';
import Testimonial from '../Testimonial';
import Div from '../Div';
import Spacing from '../Spacing';
import Insight from '../Insight';
const testimonialData = [
  {
    testimonialThumb: '/images/ceo.png',
    testimonialText:
      '"At LIXR, we focus on creating smart and practical engineering solutions. With a multidisciplinary team and a passion for innovation, we turn complexity into clarity and ideas into reality.”',
    avatarName: 'Oshan Dinilka',
    avatarDesignation: 'CEO AT LIXR',
    
  },
  {
    testimonialThumb: '/images/CTO.png',
    testimonialText:
      '"At LIXR, surpassing standards isn’t enough. We work towards setting new benchmarks in quality."',
    avatarName: 'Chathumal Ranganayaka',
    avatarDesignation: 'CTO AT LIXR',
    
  },
  {
    testimonialThumb: '/images/CFO.png',
    testimonialText:
      '"At LIXR, innovation is at the core of everything we do. We thrive by breaking norms and turning bold ideas into impacts with transparent and robust financial strategies.”',
    avatarName: 'Nethan Paul',
    avatarDesignation: 'CFO AT LIXR',
    
  },
  {
    testimonialThumb: '/images/COO.png',
    testimonialText:
      `"As COO of LIXR Innovation Company, I’m proud of our team's dedication to innovation and excellence. Together, we are shaping a dynamic future, one step at a time”`,
    avatarName: 'Hasith Seneavirathne',
    avatarDesignation: 'COO AT LIXR',
    
  },
];

export default function InsightSlider() {
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();

  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-prev slick-arrow' + (currentSlide === 0 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="bi:arrow-left" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        'slick-next slick-arrow' +
        (currentSlide === slideCount - 1 ? ' slick-disabled' : '')
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="bi:arrow-right" />
    </div>
  );
  return (
    <>
      <Div className="cs-gradient_bg_1 cs-shape_wrap_3 cs-parallax" data-aos="fade-up" data-aos-duration="2000">
        <Spacing lg="130" md="80" />
        {/* <Div className="cs-shape_3 cs-to_up">
          <img src="/images/shape_1.svg" alt="Shape" />
        </Div> */}
        <Div className="container">
          <Div className="cs-testimonial_slider">
            <Div className="cs-testimonial_slider_left">
              <Slider
                asNavFor={nav1}
                ref={slider2 => setNav2(slider2)}
                slidesToShow={3}
                swipeToSlide={true}
                focusOnSelect={true}
                centerMode={true}
                centerPadding="0px"
                arrows={false}
              >
                {testimonialData.map((item, index) => (
                  <Div className="slider-nav_item" key={index}>
                    <Div className="cs-rotate_img">
                      <Div className="cs-rotate_img_in">
                        <img src={item.testimonialThumb} alt="Thumb" />
                      </Div>
                    </Div>
                  </Div>
                ))}
              </Slider>
            </Div>
            <Div className="cs-testimonial_slider_right">
              <Slider
                asNavFor={nav2}
                ref={slider1 => setNav1(slider1)}
                prevArrow={<SlickArrowLeft />}
                nextArrow={<SlickArrowRight />}
                className="cs-arrow_style1"
              >
                {testimonialData.map((item, index) => (
                  <Div key={index}>
                    <Insight
                      testimonialText={item.testimonialText}
                      avatarName={item.avatarName}
                      avatarDesignation={item.avatarDesignation}
                    />
                  </Div>
                ))}
              </Slider>
            </Div>
          </Div>
        </Div>
        <Spacing lg="130" md="80" />
      </Div>
    </>
  );
}
